import React, { useState, useRef } from "react";
import About from "../components/About";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Services from "../components/Services";
import Why from "../components/Why";
import ServicesModal from "../components/ServicesModal";
import "../css/style.css";
import Partners from "../components/Partners";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import i18n from "i18next";

const IndexPage = () => {
  const [closed, setClosed] = useState(true);
  // const [opened, setOpen] = useState(false);

  const open = () => setClosed(true);
  const close = () => setClosed(false);

  // const openModal = () => setOpen(true);

  const { t } = useTranslation();

  const [language, setLanguage] = useState("en");

  // useEffect(() => {}, []);

  const handleOnclick = (e) => {
    e.preventDefault();

    language == "ar"
      ? setLanguage("en")
      : language == "en"
      ? setLanguage("ar")
      : setLanguage("en");

    console.log("clickedclickedclickedclicked");

    return i18n.changeLanguage(language);
  };

  const [colorChange, setColorchange] = useState(false);

  const changeNavbarColor = () => {
    // if (typeof window !== `undefined`) {
    if (window.scrollY >= 80) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
    // }
  };

  if (typeof window !== `undefined`) {
    window.addEventListener("scroll", changeNavbarColor);
  }

  const dropdown = useRef(null);

  return (
    <main>
      <head>
        <title>TechPro Page</title>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css"
        />
      </head>

      <header
        className={`
          ${colorChange ? "colorChanged" : ""}  ${language == "ar" ? "ar" : ""}
        `}
      >
        <div className="logo">
          <StaticImage src="../images/logo.svg" alt="Logo" />
        </div>

        <nav className="navLinks">
          <ul>
            <li>
              <a href="#hero">{t("home")}</a>
            </li>
            <li>
              <a href="#about">{t("about")}</a>
            </li>
            <li>
              <a href="#services">{t("services")}</a>
            </li>
            <li>
              <a href="#why">{t("why")}</a>
            </li>
            <li>
              <a href="#partners">{t("clients")}</a>
            </li>
            <li>
              <button onClick={handleOnclick}>
                {language == "ar" ? "Arabic" : "English"}
              </button>
            </li>
          </ul>
        </nav>

        <div
          className="hamburger"
          onClick={() => {
            dropdown.current.style.display = "flex";
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div ref={dropdown} className="dropdown">
          <div
            className={`
          ${`close`} ${language == "ar" ? "ar" : ""}
        `}
            onClick={() => {
              dropdown.current.style.display = "none";
            }}
          >
            <StaticImage width={30} src="../images/close.svg" alt="Logo" />
          </div>
          <ul>
            <li>
              <a href="#hero">{t("home")}</a>
            </li>
            <li>
              <a href="#about">{t("about")}</a>
            </li>
            <li>
              <a href="#services">{t("services")}</a>
            </li>
            <li>
              <a href="#why">{t("why")}</a>
            </li>
            <li>
              <a href="#partners">{t("clients")}</a>
            </li>
            <li>
              <button onClick={handleOnclick}>
                {language == "ar" ? "Arabic" : "English"}
              </button>
            </li>
          </ul>
        </div>
      </header>

      {/* <Navbar /> */}
      <Hero />
      <About language={language} />
      <Services language={language} opened={close} />
      {closed ? null : <ServicesModal closed={open} />}
      <Why language={language} />
      <Partners language={language} />
      <Footer language={language} />
    </main>
  );
};

export default IndexPage;
